import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, CreditCard, Gift, ArrowLeftRight, Settings } from "lucide-react";
import { hapticFeedback } from "../lib/telegram";

const tabs = [
  { path: "/", label: "Home", icon: Home },
  { path: "/wallet", label: "Cards", icon: CreditCard },
  { path: "/referral", label: "Earn", icon: Gift },
  { path: "/transactions", label: "Activity", icon: ArrowLeftRight },
  { path: "/settings", label: "Settings", icon: Settings },
];

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass safe-bottom">
      <div className="flex items-center justify-around h-14">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const Icon = tab.icon;

          return (
            <button
              key={tab.path}
              onClick={() => {
                if (!isActive) {
                  hapticFeedback.light();
                  navigate(tab.path);
                }
              }}
              className="relative flex flex-col items-center justify-center w-16 h-full"
            >
              {isActive && (
                <motion.div
                  layoutId="nav-indicator"
                  className="absolute top-0 left-3 right-3 h-0.5 bg-accent rounded-full"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                />
              )}
              <Icon size={22} className={isActive ? "text-ink" : "text-muted/70"} />
              <span
                className={`text-[10px] mt-0.5 ${
                  isActive ? "text-ink font-semibold" : "text-muted/70"
                }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
